<template>

    <v-flex xs12>

        <div class="action-btn-group" style="width: 100%">

            <v-btn v-for="(m, index) in buttonList" :key="index" class="action-button font-size transparent-bg" @click.prevent="$router.push({name: m.route, params: { product: productDetail }})">

                <v-layout row wrap>
                    <v-flex xs12>
                        <img style="filter: grayscale(1); width: 50%;" :src="m.image"/>
                    </v-flex>

                    <v-flex xs12 style="padding: 10px;">
                            <span class="game-action-button-title">{{ $t("game." + m.label) }}</span>
                    </v-flex>
                </v-layout>

            </v-btn>

        </div>

    </v-flex>

</template>

<script>
    export default {
        name: 'Button-Pannel',
        props: ["product"],
        data() {
            return {
                buttonList: [
                    {
                        label: 'deposit',
                        image: "//assets.office4u.xyz/photos/BO-Demo/blue-deposit-svg.svg",
                        route: "Deposit"
                    },
                    {
                        label: 'withdraw',
                        image: "//assets.office4u.xyz/photos/BO-Demo/game-withdraw.svg",
                        route: "Banklist"
                    },
                    {
                        label: 'transfer',
                        image: "//assets.office4u.xyz/photos/BO-Demo/game-transfer.svg",
                        route: "Transfer"
                    }
                ]
            }
        },
        computed: {
            productDetail: function () {
                return this.product;
            }
        }
    }
</script>

<style scope>
    .font-size {
        font-size: 11px;
    }

    .action-btn-group .v-btn__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #383838;
    }

    .action-button {
        height: 100%;
        width: 33.33%;
        padding: 20px;
        border: 0.5px solid #383838;
        font-weight: bold;
    }

    .action-btn-group .v-btn__content:hover {
        color: #3944bb;
    }

    .action-button:hover .v-btn__content .layout .flex img {
        filter: grayscale(0) !important;
    }

    .game-action-button-title{
        font-size: calc(0.6em + 1.5vmin)
    }
</style>